module.exports = __webpack_public_path__ + "img/jiaoyitongbu2.6aa6bd3f.png";